import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { Button, Offcanvas, Modal, Dropdown } from "react-bootstrap";
import { logoutUser } from "../redux/auth/actions";
import { CasinoProviders } from "../lib/data";
import { getUserBet } from "../redux/sports/actions";
import logo from "../assets/images/logo.webp";
import ToggleIcon from "../assets/images/icons/toggle-icon.png";
import TelegramIcon from "../assets/svg/TelegramIcon";
import WhatsappIcon from "../assets/svg/WhatsappIcon";
import numberWithCommas from "../utils/numbersWithComma";
import Profile from "../assets/images/icons/user-profile-wht.png";
import MyBets from "../assets/images/icons/my-bets-wht.png";
import Bonus from "../assets/images/icons/bonus-wht.png";
import Referral from "../assets/images/icons/referral-wht.png";
import Statement from "../assets/images/icons/statement-wht.png";
import SPMGames from "../assets/images/icons/spm-games.png";
import Logout from "../assets/images/icons/signout-wht.png";
import Sports from "../assets/images/games-icon/headicon/sports.png";
import Exchange from "../assets/images/games-icon/headicon/exchange.png";
import Sportsbook from "../assets/images/games-icon/headicon/sportsbook.png";
import Evolution from "../assets/images/games-icon/headicon/evolution.png";
import Ezugi from "../assets/images/games-icon/headicon/ezugi.png";
import Slots from "../assets/images/games-icon/headicon/slots.png";
import Kingmaker from "../assets/images/games-icon/headicon/kingmaker.png";
import Aviator from "../assets/images/games-icon/Aviator.png";
import GamesSearchModal from "../views/components/GamesSearchModal";
import { getNotifications } from "../redux/app/actions";
import { AiOutlineClose } from "react-icons/ai";
import { VscVerifiedFilled } from "react-icons/vsc";

const HeaderAfterLogin = () => {
  const { user, wallet, exposureAmount } = useSelector((state) => state.auth);
  const { betMatches, userBets } = useSelector((state) => state.sports);
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { appDetails } = useSelector((state) => state.app);
  const [showBetModal, setShowBetModal] = useState(false);
  const [showUserBetModal, setShowUserBetModal] = useState(false);
  const [showLeftbarToggle, setShowLeftbarToggle] = useState(false);
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(true);
  const htmlElement = document.documentElement;

  useEffect(() => {
    loadNotifications();
    return () => {};
  }, []);

  useEffect(() => {
    if (showLeftbarToggle) {
      htmlElement.style.overflow = "hidden";
      document.body.classList.add("leftbat-opened");
    } else {
      htmlElement.style.overflow = "auto";
      document.body.classList.remove("leftbat-opened");
    }
  }, [showLeftbarToggle]);

  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };

  const handleRowClick = (item) => {
    dispatch(
      getUserBet({
        skip: 0,
        pageSize: 10,
        refmatchid: item?.refMatchId,
      })
    );
    setShowBetModal(false);
    setShowUserBetModal(true);
  };

  const handleToggleClick = () => {
    const realTimeValue = !showLeftbarToggle;
    if (realTimeValue) {
      htmlElement.style.overflow = "hidden";
      document.body.classList.add("leftbat-opened");
    } else {
      htmlElement.style.overflow = "auto";
      document.body.classList.remove("leftbat-opened");
    }
    setShowLeftbarToggle(realTimeValue);
  };

  const navigationLinks = [
    { name: "Home", path: "/home" },
    { name: "Cricket", path: "/Exchange/Cricket" },
    { name: "Casino", path: "/casino" },
    { name: "Evolution", path: "/casino/evolution" },
    { name: "Ezugi", path: "/casino/ezugi" },
    { name: "Int Casino", path: "/int-casino" },
    { name: "Exchange", path: "/Exchange/Inplay" },
    { name: "Tennis", path: "/Exchange/Tennis" },
    { name: "Football", path: "/Exchange/Soccer" },
    { name: "Horse Racing", path: "/Exchange/Horse Racing" },
    { name: "Politics", path: "/Exchange/Politics" },
    { name: "Greyhound Racing", path: "/Exchange/Greyhound Racing" },
    { name: "Kabaddi", path: "/Exchange/Kabaddi" },
    { name: "Sports Book", path: "/betby" },
    { name: "Sports Book 2", path: "/sportsbook2" },
    { name: "Slots", path: "/slots" },
    { name: "Kingmaker", path: "/kingmaker" },
    { name: "Aura", path: "/aura-games" },
    { name: "Aviator", path: "/casino/spribe/aviator" },
    { name: "Ice Hockey", path: "/Exchange/Ice Hockey" },
    { name: "Basketball", path: "/Exchange/Basketball" },
    { name: "Archery", path: "/Exchange/Archery" },
    { name: "Table Tennis", path: "/Exchange/Table Tennis" },
    { name: "Badminton", path: "/Exchange/Badminton" },
    { name: "Motor Sport", path: "/Exchange/Motor Sport" },
  ];

  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu">
          <marquee>
            {websiteNotifications.map((notf, idx) => (
              <label style={{ marginRight: "30px" }} key={idx}>
                {notf?.content}
              </label>
            ))}
          </marquee>
          <span onClick={() => setShowNotifications(false)}>
            <AiOutlineClose />
          </span>
        </div>
      )) ||
        null}

      <header className="header aftrlgn">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <div className="logo">
                    <a href="/home">
                      <img src={appDetails?.LOGO_URL} alt="Logo" />
                      {/* <img src={logo} alt="Logo" /> */}
                    </a>
                  </div>
                </div>

                <div className="headerRight">
                  <GamesSearchModal />

                  <div className="rules d-none d-sm-block">
                    <a href="/gamesrule">Rules</a>
                  </div>

                  <div className="dpst-wtdrw">
                    <a href="/withdraw" className="wtdrw">
                      W
                    </a>
                    <a href="/gatewaylist" className="dpst">
                      D
                    </a>
                  </div>

                  <div className="bal-info">
                    <div>
                      <span className="d-sm-none">Bal:&nbsp;</span>
                      <span className="d-none d-sm-block">Balance:&nbsp;</span>
                      <strong>{numberWithCommas(wallet?.balance || 0)}</strong>
                    </div>
                    <div>
                      <span>Cash:&nbsp;</span>
                      <strong>{numberWithCommas(wallet?.cash || 0)}</strong>
                    </div>
                    <div>
                      <span>Bonus:&nbsp;</span>
                      <strong>{numberWithCommas(wallet?.coins)}</strong>
                    </div>
                  </div>

                  <Dropdown align="end" className="user-menu">
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      <span>{user?.mstruserid}</span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="/profile">Profile</Dropdown.Item>
                      <Dropdown.Item href="/withdraw">Withdraw</Dropdown.Item>
                      <Dropdown.Item href="/gatewaylist">Deposit</Dropdown.Item>
                      <Dropdown.Item href="/mybets">My Bets</Dropdown.Item>
                      <Dropdown.Item href="/bonus">Bonus</Dropdown.Item>
                      <Dropdown.Item href="/referral">Referral</Dropdown.Item>
                      <Dropdown.Item href="/cashier">
                        Account Statement
                      </Dropdown.Item>
                      <Dropdown.Item href="/gamesrule" className="d-sm-none">
                        Rules
                      </Dropdown.Item>
                      <Dropdown.Item
                        className="logout"
                        onClick={() => dispatch(logoutUser())}
                      >
                        Sign Out
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>

                  {/* <Button
                    variant="primary menu-btn"
                    onClick={() => setShow(true)}
                  >
                    <img
                      src={Profile}
                      alt="my menu"
                      style={{ width: "18px" }}
                    />
                  </Button> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bottom_head">
          <ul>
            {navigationLinks.map((link, index) => (
              <li key={index}>
                <NavLink
                  to={link.path}
                  className={({ isActive }) =>
                    `nav-link ${isActive ? "active" : ""} ${
                      link.name === "Sports Book 2" ? "new-badge" : ""
                    }`
                  }
                >
                  {link.name === "Sports Book 2" && (
                    <div className="new">New</div>
                  )}
                  {link.name}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>

        <Offcanvas show={show} onHide={() => setShow(false)} placement={"end"}>
          <Offcanvas.Header closeButton="closeButton" closeVariant="white">
            <Offcanvas.Title>
              <div className="d-flex">
                <div className="profile-img">
                  <img src={Profile} alt="profile" style={{ width: "24px" }} />
                </div>
                <div className="user-info">
                  <span>{user?.mstruserid}</span>
                  {/* <a href="tel:{user?.mobileno}">{user?.mobileno}</a> */}
                  <a>{user?.mobileno}</a>
                </div>
              </div>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="top_sec">
              <div className="row">
                <div className="col-6">
                  <div className="balance mb-1">Main Balance</div>
                </div>
                <div className="col-6">
                  <div className="balance-amount mb-1">
                    {numberWithCommas(wallet?.cash || 0)}
                  </div>
                </div>
                <div className="col-6">
                  <div className="balance mb-3">Bonus</div>
                </div>
                <div className="col-6">
                  <div className="balance-amount mb-3">
                    {numberWithCommas(wallet?.coins) || 0}
                  </div>
                </div>
                <div
                  className="col-6 "
                  onClick={() => {
                    navigate("/withdraw");
                  }}
                >
                  <Button variant="  w-100" className="btn-secondary">
                    Withdraw
                  </Button>
                </div>
                <div
                  className="col-6"
                  onClick={() => {
                    navigate("/gatewaylist");
                  }}
                >
                  <Button variant="primary w-100">Deposit</Button>
                </div>
                {/* <div className="col-4">
                <Button variant="primary w-100" onClick={handleShowModal}>
                  Exchange
                </Button>
                <ExchangeFundsFormPopUp
                  showexchangeModal={showexchangeModal}
                  handleCloseModal={handleCloseModal}
                />
              </div> */}
              </div>
            </div>
            <ul className="menu-items">
              <li>
                <a href="/profile">
                  <img src={Profile} alt="profile" />
                  <span>Profile</span>
                </a>
              </li>
              <li>
                <a href="/mybets">
                  <img src={MyBets} alt="my bets" />
                  <span>My Bets</span>
                </a>
              </li>
              <li>
                <a href="/bonus">
                  <img src={Bonus} alt="bonus" />
                  <span>Bonus</span>
                </a>
              </li>
              <li>
                <a href="/referral">
                  <img src={Referral} alt="referral" />

                  <span>Referral</span>
                </a>
              </li>
              <li>
                <a href="/cashier">
                  <img src={Statement} alt="account statement" />
                  <span>Account Statement</span>
                </a>
              </li>
              {/* <li>
              <a href="#">
                <SettingIcon />
                <span>Transfer Funds ( For Excahnge)</span>
              </a>
            </li> */}
              {/* <li>
              <a href="/settings">
                <SettingIcon />
                <span>Settings</span>
              </a>
            </li> */}
              <li>
                <a href="/spmgames">
                  <img src={SPMGames} alt="SPM games" />
                  <span>SPM Games</span>
                </a>
              </li>
              <li>
                <a href="/kyc">
                  <VscVerifiedFilled />
                  <span>KYC</span>
                </a>
              </li>
              <li onClick={() => dispatch(logoutUser())}>
                <a href="/">
                  <img src={Logout} alt="logout" />
                  <span>Sign Out</span>
                </a>
              </li>
            </ul>
            <ul className="social_links">
              <li>
                <a target="_blank" href={`${appDetails?.TELEGRAM}`}>
                  <TelegramIcon />
                </a>
              </li>
              {/* <li>
                <div
                  onClick={() =>
                    window.open(https://wa.me/+917888846060, "_blank")
                  }
                >
                  <WhatsappIcon />
                </div>
              </li> */}
              <li>
                <a
                  className="panel"
                  href={
                    appDetails?.WHATS_APP_URL != ""
                      ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                      : "#"
                  }
                  target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                >
                  <WhatsappIcon />
                </a>
              </li>
            </ul>
          </Offcanvas.Body>
        </Offcanvas>

        <Modal
          className="betslip_popup outer_popup"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showBetModal}
        >
          <Modal.Body>
            {" "}
            <main className="main">
              <div className="container table-responsive">
                <table className="table text-white">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Exposure amount</th>
                      <th scope="col">Match name</th>
                      <th scope="col">Ref match ID</th>
                      <th scope="col">Total bets</th>
                    </tr>
                  </thead>
                  <tbody>
                    {betMatches &&
                      betMatches.length &&
                      betMatches.map((item, index) => {
                        return (
                          <tr
                            onClick={() => {
                              handleRowClick(item);
                            }}
                          >
                            <th scope="row">{index + 1}</th>
                            <td>{item?.exposureAmount}</td>
                            <td>{item?.matchName}</td>
                            <td>{item?.refMatchId}</td>
                            <td>{item?.totalBets}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </main>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setShowBetModal(false)}>Close</Button>
          </Modal.Footer>
        </Modal>

        <Modal
          className="betslip_popup inner_popup"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showUserBetModal}
        >
          <Modal.Body>
            {" "}
            <main className="main">
              <div className="container table-responsive">
                <table className="table text-white">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Odds</th>
                      <th scope="col">Stack</th>
                      <th scope="col">Selection type</th>
                      <th scope="col">Status</th>
                      <th scope="col">Create date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userBets &&
                      userBets.length &&
                      userBets.map((item, index) => {
                        return (
                          <tr>
                            <th scope="row">{index + 1}</th>
                            <td>{item?.odds}</td>
                            <td>{item?.stack}</td>
                            <td>{item?.selectionType}</td>
                            <td>{item?.status}</td>
                            <td>{item?.createdAt}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </main>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setShowUserBetModal(false)}>Close</Button>
          </Modal.Footer>
        </Modal>
      </header>
    </>
  );
};

export default HeaderAfterLogin;
